module.exports = __webpack_public_path__ + "img/porto_getintouch-01.e068e93c.png";